<template>
    <vs-table :data="data">
      <template slot="header" >
        <vs-row style="display:inline">
          <vs-col vs-w="2">
            
          </vs-col>

            <vs-col vs-offset="7" vs-w="3" style="display:inline-flex">
             
           </vs-col>            
        </vs-row>  
      </template>
      <template slot="thead">
        <th>
          {{ $t('name') | capitalize }}
        </th>
        <th class="text-right">
          {{$tc('client') | capitalize}}
        </th>
        <th class="text-right">
          {{ $t('tacna_average') | capitalize }}
        </th>
        <th class="text-right">
          {{ $t('market_average') | capitalize }}
        </th>
        <th class="text-right">
          {{$t('contrast') | capitalize}}
        </th>
      </template>

      <template slot-scope="{ data }">
        <vs-tr :key="i" v-for="(tr, i) in data">
          <vs-td >
            {{ data[i].concepto }}
          </vs-td>
           <vs-td class="text-right">
            $ {{ (formatNumber(data[i].cliente, 2) === "NaN") ? 0 : formatNumber(data[i].cliente, 2) || 0 }}
          </vs-td>
           <vs-td class="text-right">
            $ {{(formatNumber(data[i].tacna_average,2) === "NaN") ? 0 : formatNumber(data[i].tacna_average,2) }}
          </vs-td>
           <vs-td class="text-right">
            $ {{ (formatNumber(data[i].market_average,2) === "NaN") ? 0 : formatNumber(data[i].market_average,2) }}
          </vs-td>
           <vs-td
            :class="(data[i].contrast.charAt(0) === '-') ? 'red-text' : 'green-text'" class="text-right">
            <feather-icon :icon="(data[i].contrast.charAt(0) === '-') ? 'ChevronDownIcon': 'ChevronUpIcon'" :class="(data[i].contrast.charAt(0) === '-') ? 'h-5 w-5 mr-4 red-text ': 'h-5 w-5 mr-4 green-text'"></feather-icon>
            $ {{ (data[i].contrast.charAt(0) === '-') ? formatNumber(parseFloat(data[i].contrast).toFixed(2).substr(1),2) : formatNumber(parseFloat(data[i].contrast).toFixed(2),2)}}
          </vs-td>
        </vs-tr>
        <vs-tr>
          <vs-td colspan="100%">
            <div
              v-if="data.length"
              v-observe-visibility="infiniteHandler"
            ></div>
          </vs-td>
        </vs-tr>
      </template>
    </vs-table>
</template>

<script>

export default {
  components: {
  },
  data: () => ({
    text: '',
  }),
  methods: {
    infiniteHandler(isVisible) {
      if (!isVisible) {
        return
      }
      this.$emit('loadMore')
    },
  },
  props: {
    data: {
      type: Array,
      default: () => [],
    },
  },
}
</script>

<style>
    .red-text{
        color: red;
    }
    .green-text{
        color: #17b3a3;
    }
</style>
